// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__T5-oK"};